import {primary, info, warning, danger, success} from "./colors"
import {primaryFont} from "./typography"

export const defaultTheme = {
    primaryColor: primary[1],
    primaryColorHover: primary[500],
    primaryColorActive: primary[400],
    textColor: primary[900],
    primaryFont
};